export default {
  appname: '后台管理系统',
  version: '1.0812.1213',
  uploadUrl:'/public/upload',//文件上传的url
}
